import { action } from "../../../utils/actions";

export const OPEN_SMS_GATEWAYS_LIST = action("OPEN_SMS_GATEWAYS_LIST");
export const GET_SMS_GATEWAYS = action("GET_SMS_GATEWAYS");
export const OPEN_SMS_GATEWAY_CREATION = action("OPEN_SMS_GATEWAY_CREATION");
export const CREATE_SMS_GATEWAY = action("CREATE_SMS_GATEWAY");
export const OPEN_SMS_GATEWAY_EDITION = action("OPEN_SMS_GATEWAY_EDITION");
export const EDIT_SMS_GATEWAY = action("EDIT_SMS_GATEWAY");
export const REMOVE_SMS_GATEWAY = action("REMOVE_SMS_GATEWAY");
export const PING_IOT_DEVICE = action("PING_IOT_DEVICE");
export const LIST_AVAILABLE_IOT_DEVICES = action("LIST_AVAILABLE_IOT_DEVICES");
